export class CompanySellerAssignmentError extends Error {
    constructor() {
        super('Account saved, but its owner could not be saved')
        this.name = 'CompanySellerAssignmentError'
    }
}
